export const base = {
  py: 0,
  px: ["s500", null, "s700"],
  mx: "auto",
  maxWidth: "base",
};

export const baseNoGutters = {
  variant: "layout.base",
  px: [0, null, 0],
};

// Theme UI uses container as our default.
export const container = {
  variant: "layout.base",
};

export const wide = {
  variant: "layout.base",
  maxWidth: "wide",
};

export const wideNoGutters = {
  variant: "layout.wide",
  px: [0, null, 0],
};

export const small = {
  variant: "layout.base",
  maxWidth: "small",
};

export const smallNoGutters = {
  variant: "layout.small",
  px: [0, null, 0],
};

export const account = {
  variant: "layout.base",
  px: "s200",
  maxWidth: "account",
};
